(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    const header = e.target.closest('.footer-accordion-header');
    if (!header) return;

    if (window.innerWidth > 749) return;

    const block = header.closest('.footer-block');
    const content = block.querySelector('.footer-block__accordion-content');
    const icon = block.querySelector('.footer-accordion-icon');

    if (!content) return;

    // close others
    document.querySelectorAll('.footer-block').forEach((b) => {
      if (b === block) return;

      b.querySelector('.footer-block__accordion-content')?.classList.remove('active');
      const ic = b.querySelector('.footer-accordion-icon');
      if (ic) ic.textContent = '+';
    });

    // toggle current
    content.classList.toggle('active');

    const isOpen = content.classList.contains('active');
    icon.textContent = isOpen ? '−' : '+';
  });
  document.addEventListener('click', function (e) {
    if (!e.target.classList.contains('footer-menu__toggle')) return;

    const currentLi = e.target.closest('li');
    const currentSubmenu = currentLi.querySelector(':scope > .footer-menu__submenu');

    if (!currentSubmenu) return;

    const parentUl = currentLi.parentElement;

    // Close all sibling accordions
    parentUl.querySelectorAll(':scope > li').forEach((li) => {
      if (li === currentLi) return;

      const submenu = li.querySelector(':scope > .footer-menu__submenu');
      const toggle = li.querySelector(':scope > .footer-menu__header .footer-menu__toggle');

      if (submenu) {
        submenu.classList.remove('active');
      }

      if (toggle) {
        toggle.textContent = '+';
      }

      // Close nested accordions too
      li.querySelectorAll('.footer-menu__submenu').forEach((nested) => {
        nested.classList.remove('active');
      });

      li.querySelectorAll('.footer-menu__toggle').forEach((nestedToggle) => {
        nestedToggle.textContent = '+';
      });
    });

    // Toggle current accordion
    currentSubmenu.classList.toggle('active');

    e.target.textContent = currentSubmenu.classList.contains('active') ? '−' : '+';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
